import React, { Component } from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';

class Form extends Component {
  handleSubmit(event){
    event.preventDefault();
    this.props.onSubmit(serialize(event.target,{
      hash:true,
      empty:this.props.includeEmpty
    }));
  }

  render(){
    return (
      <form
        onSubmit={(e) => this.handleSubmit(e)}
        autoComplete={this.props.allowAutoComplete ? 'on' : 'off'}
      >
        {this.props.children}
      </form>
    );
  }
}

Form.propTypes = {
  children:PropTypes.node.isRequired,
  onSubmit:PropTypes.func,
  onValidate:PropTypes.func,
  onValidateError:PropTypes.func,
  onValidateSuccess:PropTypes.func,
  includeEmpty:PropTypes.bool,
  resetOnSubmit:PropTypes.bool,
  allowAutoComplete:PropTypes.bool
};

Form.defaultProps = {
  onSubmit:() => {},
  onValidate:() => {},
  onValidateError:() => {},
  onValidateSuccess:() => {},
  allowAutoComplete:true
};

export default Form;



// WEBPACK FOOTER //
// ./src/shared/components/Form/Form.js